<template>
  <div class="report-referred-request">

      <v-row class="report-date-picker">
        <div class="col-6">
          <label class="from">{{ $t('fromDate') }}</label>
          <date-picker v-model="start_date"></date-picker>
        </div>
        <div class="col-6">
          <label class="to">{{ $t('toDate') }}</label>
          <date-picker v-model="end_date"></date-picker>
        </div>
      </v-row>
      <div>
<!--        <v-row-->
<!--          v-for="(item, i) in request_items"-->
<!--          :key="i"-->
<!--          cols="12"-->
<!--        >-->
<!--          <v-col cols="12">-->
        <div v-for="(item, i) in request_items"
             :key="i"
             class="req-item"
        >
          <v-card
          >
            <v-card-title class="headline req-title">
              شماره درخواست: {{item.RequestCode}}
            </v-card-title>

            <div class="req-date">
              تاریخ ارجاع: {{item.ReferDate}}

            </div>
            <div class="req">
              درخواست: {{item.RequestName}}
            </div>
            <div class="address" v-if="get_request_address(item) != ''">
              آدرس:
              {{get_request_address(item)}}
            </div>
            <v-card-actions>
              <v-btn text class="last-status" >
                {{item.LastStatus}}
              </v-btn>
              <v-icon v-if="item.ImageStatus==0||item.ReceiveSignature==0 || item.SendSignature==0" >
                mdi-cog
              </v-icon>
            </v-card-actions>
          </v-card>
        </div>

<!--          </v-col>-->
<!--        </v-row>-->
      </div>

  </div>


</template>
<script>
  import Vue from 'vue';
  import moment from 'moment-jalaali'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
  Vue.component('date-picker', VuePersianDatetimePicker);
  export default {
    props:[
      'passing_data'
    ],
    data() {
      return {
        errors: [],
        start_date: '',
        end_date: '',
        request_items:[],

      }
    },components:{
      datePicker: VuePersianDatetimePicker

    },
    watch: {
      'start_date': function () {
        this.get_report(0);

      },
      'end_date': function () {
        this.get_report(0);

      },


    }, mounted() {
      this.start_date = moment().utc().format('jYYYY/jMM/jDD')
      this.end_date = moment().utc().format('jYYYY/jMM/jDD')

        this.get_report(0);
    },
    methods: {
      get_request_address (item) {
        var address = "";
        if(item.CityName != null){
          address +=  item.CityName+" ";
        }
        if(item.AreaName != null){
          address +=  item.AreaName+" ";
        }
        if(item.AddressText != null){
          address +=  item.AddressText+" ";
        }
        return address
      },
      goToDetail (item_id) {
        this.$router.push({ name: 'groups', params: {} })
      },
      get_report(page) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId

        const send_data = {
            "UserId": user_id,
            "FirstDate": this.start_date,
            "SecondDate": this.end_date,
            "Page": page,

          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/GetRequestRefersRptByUserId', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                // console.log("response", response);
                // self.user_registered = true;
                // self.fullName = response.data.msg;
                // self.level = 2;
                if(page==0){
                  self.request_items = response.data.refers;
                }else{
                  response.data.refers.forEach(function (number) {
                   self.request_items.push(number);
                  });
                }
              }else{
                self.not_register = true;
              }
              // this.$router.push({ path: "/post-login", params: {} });

            }).catch(e => {
            this.errors.push(e);

          })

      },

    }
  }
</script>
